export function isDeviceMobile() {
	const regex =
		/Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
	return regex.test(navigator.userAgent)
}

export function isDeviceSafari() {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}
